/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addImportRows } from '../fn/waba-import-api/add-import-rows';
import { AddImportRows$Params } from '../fn/waba-import-api/add-import-rows';
import { ApiResponseImportJobView } from '../models/api-response-import-job-view';
import { ApiResponseImportPageImportJobView } from '../models/api-response-import-page-import-job-view';
import { ApiResponseImportPageImportRowView } from '../models/api-response-import-page-import-row-view';
import { ApiResponseImportProfile } from '../models/api-response-import-profile';
import { cancelImport } from '../fn/waba-import-api/cancel-import';
import { CancelImport$Params } from '../fn/waba-import-api/cancel-import';
import { checkImport } from '../fn/waba-import-api/check-import';
import { CheckImport$Params } from '../fn/waba-import-api/check-import';
import { commitImport } from '../fn/waba-import-api/commit-import';
import { CommitImport$Params } from '../fn/waba-import-api/commit-import';
import { createImport } from '../fn/waba-import-api/create-import';
import { CreateImport$Params } from '../fn/waba-import-api/create-import';
import { editImportRows } from '../fn/waba-import-api/edit-import-rows';
import { EditImportRows$Params } from '../fn/waba-import-api/edit-import-rows';
import { importHistory } from '../fn/waba-import-api/import-history';
import { ImportHistory$Params } from '../fn/waba-import-api/import-history';
import { importProfile } from '../fn/waba-import-api/import-profile';
import { ImportProfile$Params } from '../fn/waba-import-api/import-profile';
import { importRows } from '../fn/waba-import-api/import-rows';
import { ImportRows$Params } from '../fn/waba-import-api/import-rows';
import { importStatus } from '../fn/waba-import-api/import-status';
import { ImportStatus$Params } from '../fn/waba-import-api/import-status';

@Injectable({ providedIn: 'root' })
export class WabaImportApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `importHistory()` */
  static readonly ImportHistoryPath = '/v1/api/ui/imports';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  importHistory$Response(params?: ImportHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportPageImportJobView>> {
    return importHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  importHistory(params?: ImportHistory$Params, context?: HttpContext): Observable<ApiResponseImportPageImportJobView> {
    return this.importHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportPageImportJobView>): ApiResponseImportPageImportJobView => r.body)
    );
  }

  /** Path part for operation `createImport()` */
  static readonly CreateImportPath = '/v1/api/ui/imports';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createImport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createImport$Response(params: CreateImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
    return createImport(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createImport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createImport(params: CreateImport$Params, context?: HttpContext): Observable<ApiResponseImportJobView> {
    return this.createImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportJobView>): ApiResponseImportJobView => r.body)
    );
  }

  /** Path part for operation `importProfile()` */
  static readonly ImportProfilePath = '/v1/api/ui/imports/profiles/{entityType}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  importProfile$Response(params: ImportProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportProfile>> {
    return importProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  importProfile(params: ImportProfile$Params, context?: HttpContext): Observable<ApiResponseImportProfile> {
    return this.importProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportProfile>): ApiResponseImportProfile => r.body)
    );
  }

  /** Path part for operation `importStatus()` */
  static readonly ImportStatusPath = '/v1/api/ui/imports/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  importStatus$Response(params: ImportStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
    return importStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  importStatus(params: ImportStatus$Params, context?: HttpContext): Observable<ApiResponseImportJobView> {
    return this.importStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportJobView>): ApiResponseImportJobView => r.body)
    );
  }

  /** Path part for operation `importRows()` */
  static readonly ImportRowsPath = '/v1/api/ui/imports/{reference}/rows';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importRows()` instead.
   *
   * This method doesn't expect any request body.
   */
  importRows$Response(params: ImportRows$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportPageImportRowView>> {
    return importRows(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importRows$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  importRows(params: ImportRows$Params, context?: HttpContext): Observable<ApiResponseImportPageImportRowView> {
    return this.importRows$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportPageImportRowView>): ApiResponseImportPageImportRowView => r.body)
    );
  }

  /** Path part for operation `addImportRows()` */
  static readonly AddImportRowsPath = '/v1/api/ui/imports/{reference}/rows';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addImportRows()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addImportRows$Response(params: AddImportRows$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
    return addImportRows(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addImportRows$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addImportRows(params: AddImportRows$Params, context?: HttpContext): Observable<ApiResponseImportJobView> {
    return this.addImportRows$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportJobView>): ApiResponseImportJobView => r.body)
    );
  }

  /** Path part for operation `editImportRows()` */
  static readonly EditImportRowsPath = '/v1/api/ui/imports/{reference}/rows/edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editImportRows()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editImportRows$Response(params: EditImportRows$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
    return editImportRows(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editImportRows$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editImportRows(params: EditImportRows$Params, context?: HttpContext): Observable<ApiResponseImportJobView> {
    return this.editImportRows$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportJobView>): ApiResponseImportJobView => r.body)
    );
  }

  /** Path part for operation `checkImport()` */
  static readonly CheckImportPath = '/v1/api/ui/imports/{reference}/check';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkImport()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkImport$Response(params: CheckImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
    return checkImport(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkImport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkImport(params: CheckImport$Params, context?: HttpContext): Observable<ApiResponseImportJobView> {
    return this.checkImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportJobView>): ApiResponseImportJobView => r.body)
    );
  }

  /** Path part for operation `commitImport()` */
  static readonly CommitImportPath = '/v1/api/ui/imports/{reference}/commit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commitImport()` instead.
   *
   * This method doesn't expect any request body.
   */
  commitImport$Response(params: CommitImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
    return commitImport(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commitImport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commitImport(params: CommitImport$Params, context?: HttpContext): Observable<ApiResponseImportJobView> {
    return this.commitImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportJobView>): ApiResponseImportJobView => r.body)
    );
  }

  /** Path part for operation `cancelImport()` */
  static readonly CancelImportPath = '/v1/api/ui/imports/{reference}/cancel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelImport()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelImport$Response(params: CancelImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportJobView>> {
    return cancelImport(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelImport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cancelImport(params: CancelImport$Params, context?: HttpContext): Observable<ApiResponseImportJobView> {
    return this.cancelImport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseImportJobView>): ApiResponseImportJobView => r.body)
    );
  }

}
